import updateJob from './updateJob';
import { IS_OPEN_TRUE } from '../assets/constants/jobConstants';

const reopenJob = async (job) => {
  const { id, lastUpdate } = job;
  const jobToReopen = {
    id,
    lastUpdate,
    isOpen: IS_OPEN_TRUE,
    closedFilledDate: '',
    closedFilled: '',
    numberApplicants: '',
    numberApplicantsInterviewed: '',
    numberOffersMade: '',
  };

  return updateJob(jobToReopen);
};

export default reopenJob;
